<div class="layout-column custom-panel full-width full-height">
  <form class="flex layout-column" [formGroup]="draftTemplateForm" (ngSubmit)="onSubmit()">
    <div class="layout-row layout-align-start-center header padding-10">
      <span class="br-body-2 font-weight-600 primary-100" translate>Default Draft</span>
      <span class="flex"></span>
      <bringoz-button type="tertiary"
                      (onClick)="onClose.emit()">
        <bringoz-icon iconName="close" class="secondary-100"></bringoz-icon>
      </bringoz-button>
    </div>
    <hr class="main-divider">
    <div class="flex layout-column padding-10">
      <div *ngIf="defaultDraftId" class="layout-row layout-align-start-center">
        <app-bringoz-radio-button
          class="margin-right-10"
          [value]="'update'"
          (onValueChange)="formType = 'update'"
          [isSelected]="formType === 'update'">
          <span>Edit and update</span>
        </app-bringoz-radio-button>

        <app-bringoz-radio-button
          [value]="'create'"
          (onValueChange)="formType = 'create'"
          [isSelected]="formType === 'create'">
          <span>Create</span>

        </app-bringoz-radio-button>
      </div>

      <div class="layout-column margin-top-10">
        <div class="input-container">
          <label class="form-label" translate>Name</label>
          <input
            class="form-control"
            formControlName="name"
            type="text"
          />
        </div>

      </div>


    </div>
    <hr class="main-divider">
    <div class="layout-row layout-align-start-center padding-10">
      <bringoz-button type="tertiary"
                      (onClick)="onClose.emit()">
        <span translate>Cancel</span>
      </bringoz-button>

      <span class="flex"></span>
      <bringoz-button buttonType="submit" theme="secondary">
        {{ 'Submit' | translate }}
      </bringoz-button>
    </div>
  </form>
</div>
